export const deviceStatus =  [
    {
      name: "待激活",
      value: 0,
    },
    {
      name: "已激活",
      value: 1,
    },
    {
      name: "已安装",
      value: 2,
    }
  ]

  export const sellType =  [
    {
      name: "押金",
      value: 'dep',
    },
    {
      name: "推荐售出",
      value: 'sell',
    },
    {
      name: "商城购买",
      value: 'store',
    }
  ]